export default __webpack_public_path__ + "static/media/cardadmin.8443eb71.png";